import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';

import { Modal, Button, Input } from '@netexknowledge/smart-components';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as messageAlert from '../../../actions/messageAlertAction';

class EditGroupReveal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupName: '',
      isLoading: false
    };
  }

  static propTypes = {
    group: PropTypes.object,
    classroomGroupActions: PropTypes.object,
    messageAlert: PropTypes.object
  };

  componentDidUpdate(prevProps) {
    if (prevProps.group !== this.props.group && this.props.group) {
      this.setState({
        groupName: this.props.group.name || ''
      });
    }
  }

  handleInputChange = (event) => {
    this.setState({
      groupName: event.target.value
    });
  };

  handleEditGroup = async () => {
    const { groupName } = this.state;
    const { group, classroomGroupActions, messageAlert } = this.props;

    console.log('EditGroup - Starting edit process:', {
      groupId: group.id,
      currentName: group.name,
      newName: groupName.trim()
    });

    if (!groupName.trim()) {
      messageAlert.error(I18n.t('groups.emptyName'));
      return;
    }

    if (groupName.trim() === group.name) {
      messageAlert.info(I18n.t('common.empty'));
      return;
    }

    this.setState({ isLoading: true });

    try {
      await classroomGroupActions.editGroup(group.id, groupName.trim());
      messageAlert.success(I18n.t('gradebook.changesSaved'));
      
      // Cerrar el modal y limpiar el estado
      this.closeModal();
    } catch (error) {
      console.error('EditGroup - Error:', error);
      messageAlert.error(I18n.t('error.valueRequired'));
    } finally {
      this.setState({ isLoading: false });
    }
  };

  closeModal = () => {
    const { classroomGroupActions } = this.props;
    classroomGroupActions.setEditGroupIsOpen(false);
    classroomGroupActions.setGroupToEdit(null);
  };

  render() {
    const { group } = this.props;
    const { groupName, isLoading } = this.state;

    return (
      <Modal
        id="edit-group"
        title={I18n.t('common.option.edit')}
        active={!!group}
        onClickOutside={this.closeModal}
        footer={
          <>
            <Button onClick={this.closeModal} disabled={isLoading} label={I18n.t('common.cancel')}></Button>
            <Button 
              onClick={this.handleEditGroup} 
              primary 
              disabled={isLoading || !groupName.trim()}
              label={I18n.t('common.option.save')}
            ></Button>
          </>
        }
      >
        <div style={{ marginBottom: '16px' }}>
          <Input
            id="group-name-input"
            type="text"
            value={groupName}
            onChange={this.handleInputChange}
            placeholder={I18n.t('addGroupPopup.placeholder')}
            disabled={isLoading}
            maxLength={50}
          />
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    group: state.group.groupToEdit,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditGroupReveal);
